import {
  Box,
  Collapse,
  Paper,
  Typography,
  styled,
} from '@mui/material';
import { CaretDown } from '@phosphor-icons/react';
import React, { useState } from 'react';

interface ExpandableTextboxProps {
  title: string;
  text: string | React.ReactNode;
  defaultOpen?: boolean;
}

const QuestionHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: theme.palette.grey[50],
  borderRadius: theme.shape.borderRadius,
}));

const AnswerContent = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const ExpandableTextbox: React.FC<ExpandableTextboxProps> = ({
  title,
  text,
  defaultOpen = false
}) => {
  const [expanded, setExpanded] = useState(defaultOpen);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  return (
    <Paper variant="outlined" sx={{ overflow: 'hidden' }}>
      <QuestionHeader onClick={toggleExpand}>
        <Typography variant="body1" fontWeight={500}>
          {title}
        </Typography>
        <CaretDown
          size={24}
          style={{
            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s',
          }}
        />
      </QuestionHeader>
      <Collapse in={expanded}>
        <AnswerContent>
          {typeof text === 'string' ? (
            <Typography variant="body2" color="text.secondary">
              {text}
            </Typography>
          ) : (
            text
          )}
        </AnswerContent>
      </Collapse>
    </Paper>
  );
};

export default ExpandableTextbox; 